import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';

class EachUser extends Component {
    render() {
    	return(
			<div className="patient anim1 br5" style={{backgroundColor: (this.props.index % 2 === 0 ? '#FAFAFA' : '#FFFFFF')}}>
				<div className="row patientRow">
					<div className="rt" style={{width: '15%', float: 'left'}}><span className="mobileShowIB"><strong>First Name:</strong></span> {this.props.children.first_name}</div>
					<div className="rt" style={{width: '15%', float: 'left'}}><span className="mobileShowIB"><strong>Last Name:</strong></span> {this.props.children.last_name}</div>
					<div className="rt" style={{width: '25%', float: 'left'}}><span className="mobileShowIB"><strong>Email Address:</strong></span> {this.props.children.email}</div>
					<div className="rt" style={{width: '10%', float: 'left'}}><span className="mobileShowIB"><strong>Permissions:</strong></span> {this.props.children.permissions}</div>
					<div className="rt" style={{width: '10%', float: 'left'}}><span className="mobileShowIB"><strong>Centre:</strong></span> {this.props.children.Centre === null || this.props.children.Centre === '' ? 'NA' : this.props.children.Centre}</div>
					<div className="rt" style={{width: '15%', float: 'left'}}><span className="mobileShowIB"><strong>Last Login:</strong></span> {this.props.children.last_login}</div>
					<div className="rt" style={{width: '10%', float: 'left'}}>
						<span className="mobileShowIB"><strong>Actions:</strong></span>
						<Link className="patientLink" to={'/users/' + this.props.children.id}><span className="fas fa-pen"></span></Link>
						<button style={{ marginLeft: 15 }} className="patientLink" onClick={() => this.props.deleteUser(this.props.children.id)}><span className="fas fa-trash"></span></button>
					</div>
				</div>
			</div>
    	);
    }
}

export default EachUser;



// WEBPACK FOOTER //
// ./src/components/EachUser.js